import { numberMoney } from 'Data/format.js'
import { getInsuranceTreatmentFee } from 'Data/payment-plan.js'

export function getValue(payment_plan) {
  return numberMoney(getInsuranceTreatmentFee(payment_plan))
}
